import React from 'react'
import ReactDOM from 'react-dom/client'
import './utils/attribution.js' // capture ?utm_*/?fbclid= before any redirect can drop them
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
